import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/nde/service_banner.webp";

function Servicende() {
  return (
    <section
      className="service_nde text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-7 offset-lg-7 offset-md-7"
          >
            <h2>Core Services</h2>
            <p>
              NDE Offshore is a Swedish-based, leading offshore service provider
              in Europe and the Middle East. Their core services include
              complete inspection, repair, and maintenance (IRM) solutions for
              the offshore wind, oil, and gas industries globally.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Servicende;
